import React from "react";
import { Box, Typography } from "@mui/material";
import { Icon } from "@iconify/react";
import { motion } from "framer-motion";
import { LUXURY, IMAGE_CARD_FRAME } from "data/guestLuxuryTheme";

const ConciergeBanner = ({ onClick }) => (
  <Box
    component={motion.div}
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    sx={{
      position: "relative",
      overflow: "hidden",
      minHeight: 118,
      borderRadius: "20px",
      border: IMAGE_CARD_FRAME.border,
      boxShadow: IMAGE_CARD_FRAME.boxShadow,
    }}
  >
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        backgroundImage: `url(${LUXURY.headerImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center 60%",
      }}
    />
    <Box
      sx={{
        position: "absolute",
        inset: 0,
        background:
          "linear-gradient(90deg, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.38) 55%, rgba(0,0,0,0.2) 100%)",
      }}
    />
    <Box
      sx={{
        position: "relative",
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        gap: 1.2,
        minHeight: 118,
        px: 2.1,
        py: 1.8,
      }}
    >
      <Typography
        sx={{
          fontFamily: LUXURY.displayFont,
          fontWeight: 500,
          fontSize: "1.15rem",
          lineHeight: 1.2,
          color: "#fff",
          maxWidth: "70%",
        }}
      >
        Need anything during your stay?
      </Typography>
      <Box
        component="button"
        type="button"
        onClick={onClick}
        sx={{
          appearance: "none",
          border: 0,
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          gap: 0.6,
          minHeight: 38,
          px: 1.85,
          borderRadius: 999,
          background: LUXURY.ctaGradient,
          color: LUXURY.forestDeep,
          fontWeight: 700,
          fontSize: "0.82rem",
          fontFamily: LUXURY.bodyFont,
          boxShadow: LUXURY.ctaShadow,
          WebkitTapHighlightColor: "transparent",
          "&:active": { transform: "scale(0.98)" },
        }}
      >
        Contact Concierge
        <Icon icon="mdi:chevron-right" width={18} height={18} color="currentColor" />
      </Box>
    </Box>
  </Box>
);

export default ConciergeBanner;
